import { useLocation } from "react-router-dom";

export const useIsInChat = () => {
  const location = useLocation();
  const isInChat = location.pathname.includes("chat");
  return { isInChat };
};
